import { useState, useEffect } from 'react';
import '../../../index.css';
import { withLocale } from "../../../l10n";
import DataTable from '../../../components/DataTable/DataTable';
import service from '../../../services/Service';

function PoolTable({ lang }) {

  // ===== 1. ESTADOS =====
  const [datos, setDatos] = useState([]);
  const [loading, setLoading] = useState(false);

  // ===== 4. HELPERS (Funciones auxiliares) =====
  const formatBytes = (bytes) => {
    if (bytes < 1024) return { value: bytes, tag: 'Bytes' };
    if (bytes < 1024 * 1024) return { value: (bytes / 1024).toFixed(2), tag: 'KB' };
    if (bytes < 1024 * 1024 * 1024) return { value: (bytes / 1024 / 1024).toFixed(2), tag: 'MB' };
    return { value: (bytes / 1024 / 1024 / 1024).toFixed(2), tag: 'GB' };
  };

  const renderCommercialGroup = (data) => {
    if (!data) return null;
    
    let number;
    let processedData = data.replaceAll('_', ' ');

    if (processedData.includes('ZONA')) {
      processedData = processedData.slice(0, -5);
      number = processedData[processedData.length - 1];
      processedData = processedData.slice(0, -1) + ' ' + number;
    } else if (processedData.includes('eur')) {
      number = processedData.indexOf(' ', (processedData.indexOf(' ') + 1));
      processedData = processedData.slice(0, -(processedData.length - number)) + ' EU';
    } else if (processedData.includes('Sin Asignar')) {
      processedData = lang.handle('Sin asignar');
    }

    return <p>{processedData}</p>;
  };

  const renderConsumedData = (data) => {
    const isOverLimit = data.consumedData > data.limitData;
    const consumed = formatBytes(data.consumedData);
    const limit = formatBytes(data.limitData);

    return (
      <p>
        <span className={isOverLimit ? 'text-danger' : ''}>
          {consumed.value} {consumed.tag}
        </span>
        {' / '}
        {limit.value} {limit.tag}
      </p>
    );
  };

  // ===== 5. FUNCIONES PRINCIPALES =====
  useEffect(() => {
    const fetchPools = async () => {
      setLoading(true);
      try {
        const res = await service.get('pools');
        setDatos(Array.isArray(res?.data) ? res.data : []);
      } catch (err) {
        console.error('Error al obtener pools:', err);
        setDatos([]);
      } finally {
        setLoading(false);
      }
    };
    fetchPools();
  }, []);

  // ===== 8. CONFIG (columnas, etc) =====
  const columns = [
    {
      title: lang.handle('Grupo comercial'),
      dataIndex: ['commercialGroup'],
      render: (data) => renderCommercialGroup(data)
    },
    {
      title: lang.handle('Tarjetas activas / tarjetas totales'),
      dataIndex: ['activeSim'],
      render: (data) => <p> {data.activeCards} / {data.totalSim} </p>
    },
    {
      title: lang.handle('Consumo del pool / Pool total'),
      dataIndex: ['consumedData'],
      render: (data) => renderConsumedData(data)
    },
  ];

  // ===== 9. RENDER =====
  return (
    <div>
      <DataTable
        columns={columns}
        dataSource={datos}
        pagination={false}
        rowKey="pool_id"
        loading={loading}
        scroll={{ x: 'max-content' }}
      />
    </div>
  );
};

export default withLocale(PoolTable);
